import AntdApp from 'antd/es/app';
import styled from 'styled-components';
export const AntdAppContainer = styled(AntdApp) `
  height: 100%;
`;
